import './styles/main.css';
import { startApp } from './app';
import { armAudioUnlock } from './services/celebrationSound';
import { completeExpiredChallenge } from './services/challenge';
import { getOrCreateProgressState, runDayRollover } from './services/dailyRollover';
import { announceStreakIncrease } from './ui/celebration';
import { todayIso } from './utils/date';

async function registerServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) return;
  await navigator.serviceWorker.register('/sw.js');
}

/**
 * Geliştirme sırasında skorlama doğrulamasını tarayıcı konsoluna bağlar.
 *
 * `import.meta.env.DEV` yalnızca `npm run dev` sırasında true'dur;
 * `npm run build` ile üretilen sürümde bu blok tamamen silinir, yani
 * doğrulama kodu kullanıcıya gitmez.
 */
async function exposeDevTools(): Promise<void> {
  if (!import.meta.env.DEV) return;

  const { runScoringVerification } = await import('./services/scoring.verify');
  Object.assign(window, { runScoringVerification });
  console.info(
    'Skorlama formüllerini doğrulamak için konsola şunu yaz: runScoringVerification()',
  );
}

async function bootstrap(): Promise<void> {
  const root = document.getElementById('app');
  if (!root) {
    throw new Error('#app root element not found in index.html');
  }

  await registerServiceWorker();

  // Kutlama sesi için ses kanalını hazırla. iOS ses çalmayı ilk
  // dokunuşa kadar engellediğinden, dinleyiciyi en baştan kuruyoruz.
  armAudioUnlock();

  // Gün kapanışı seriyi artırmış olabilir; karşılaştırabilmek için
  // ÖNCEKİ değeri kapanıştan hemen önce okuyoruz.
  const progressBefore = await getOrCreateProgressState();

  // Ekranı çizmeden ÖNCE kapanmamış günleri kapat (§7.2). Böylece
  // kullanıcı uygulamayı açtığında, dün gece kesinleşen puanı ve
  // güncel streak'i görür.
  const rollover = await runDayRollover();

  // Süresi dolmuş challenge'ı kapat (§7.4). Gün kapanışından SONRA
  // çalışmalı: kapanış, challenge'ın son günlerini streak hesabına
  // katarken onu hâlâ aktif görmeli.
  await completeExpiredChallenge(todayIso());

  await startApp(root);
  await exposeDevTools();

  // Kutlama en SONA bırakıldı: ekran çizilmeden açılsaydı, kutlama
  // kapandığında arkasında boş bir sayfa kalırdı.
  if (rollover.state.currentStreak > progressBefore.currentStreak) {
    await announceStreakIncrease(
      rollover.state.currentStreak,
      rollover.state.longestStreak,
    );
  }
}

bootstrap().catch((error) => {
  console.error('Failed to start app', error);
});
